export default {"src":"/_next/static/media/sedom.b2eddd90.svg","height":25,"width":160,"blurWidth":0,"blurHeight":0};